var BaseView = require('./logos-view');

module.exports = BaseView.extend({
  template: require('./icons.hbs')
});
